exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* purgecss start ignore */\n#location-label[data-v-4c559fc6] {\n  font-size: 18px;\n  padding-right: 10px;\n  white-space: nowrap;\n  font-weight: 600;\n}\n.multiselect-holder[data-v-4c559fc6]{\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n\n/* purgecss end ignore */\n\n", ""]);

// exports
